// extracted by css-extract-rspack-plugin
export default {"root":"root-TLFZGt","avatar":"avatar-SZGb0H","link":"link-tm4Odm","person":"person-GpDJ_R","lead":"lead-kQqDU9","action":"action-Rz8ont"};